import {
  BILLING_RETRIEVAL_SURFACE_CONFIG,
  buildRetrievalBillingPayload,
  getBillingRetrievalSurfaceConfig,
} from "../../../features/bonds/shared/billingSurfaceConfig";

export { buildRetrievalBillingPayload as buildBillingPayload };

export const BILLING_RETRIEVAL_CONFIG = BILLING_RETRIEVAL_SURFACE_CONFIG;

export function getBillingRetrievalConfig(bondType) {
  return getBillingRetrievalSurfaceConfig(bondType);
}
